<template>
  <transition name="fade">
    <!-- eslint-disable -->
    <div
      v-if="visible"
      class="modal detail_box"
      style="z-index:101;"
    >

      <div class="detail">
        <input
          style="display:none;"
          type="file"
          multiple="multiple"
          id="fileMoreUpSend"
          name="file"
          @change="onFileMoreUpSend($event)"
        >
        <div class="titles msp_icon_close">
          <span class="title_name">上传素材</span>
          <span
            v-if="uploadMatterType === 'video'"
            class="title_name"
            style="color:#F56969;"
          >（每次只能上传一个5G以下的视频）</span>
          <span
            v-if="uploadMatterType === 'audio'"
            class="title_name"
            style="color:#F56969;"
          >（每次只能上传一个5G以下的音频）</span>

          <span
            v-if="uploadMatterType === 'file'"
            class="title_name"
            style="color:#F56969;"
          >（每次只能上传一个5G以下的附件）</span>

          <span
            class="iconfont el-icon-close"
            @click.stop="closeBox()"
          />
        </div>
        <div class="detail_el_scroll">
          <div class="bottom_button">
            <div class="bottom_content">
              <el-button
                v-if="!isUploadIng"
                type="primary"
                @click.native="sureUploadMatter()"
              >确定</el-button>
            </div>
          </div>

          <div class="upload_matter_info">
            <div class="upload_matter_button">
              <el-button
                v-if="uploadMatterType === 'video' && !isUploadIng"
                type="primary"
                round
                @click.native="uploadMatter()"
              >添加视频</el-button>
              <el-button
                v-if="uploadMatterType === 'audio' && !isUploadIng"
                type="primary"
                round
                @click.native="uploadMatter()"
              >添加音频</el-button>
              <el-button
                v-if="uploadMatterType === 'file' && !isUploadIng"
                type="primary"
                round
                @click.native="uploadMatter()"
              >添加附件</el-button>
              <span :title="fileAllName.name">{{ fileAllName.name }}</span>
            </div>
            <div class="upload_progress">
              <el-progress
                :text-inside="true"
                :stroke-width="24"
                :percentage="progressBar"
                status="success"
              ></el-progress>
            </div>
            <div
              class="upload_each_info_detail"
              style="padding-left:64px;"
            >
              <el-button
                type="primary"
                style="height:32px;width:90px;padding:0;"
                @click.native='choiceMatterFolder()'
              >文件夹选择</el-button>
              <span
                style="color:#688EFF;line-height:32px;margin-left:10px;"
                class="need_textdot"
              >{{ currentMatterFolder.currentFolderLocation }}</span>
            </div>

            <div
              class="upload_each_info_detail upload_input_info_detail"
              style="padding-left:68px;"
            >
              <span class="star">*</span>
              <span>素材名称：</span>
              <el-input
                v-model="uploadPicObj.title"
                placeholder="请输入素材名称"
                :disabled='isUploadIng'
              ></el-input>
            </div>

            <div class="upload_each_info_detail">
              <span>上&nbsp;&nbsp;传&nbsp;&nbsp;者：</span>
              <span class="need_textdot">{{ username }}</span>
            </div>

            <div class="upload_each_info_detail upload_input_tags_detail">
              <span>素材标签：</span>
              <el-cascader
                v-model="uploadPicObj.tagIds"
                :options="tagsTree"
                :props='cascaderProps'
                :size='cascaderSize'
                :show-all-levels="false"
                ref='cascaderref'
                filterable
                :disabled='isUploadIng'
                @change="handleChange"
              ></el-cascader>
            </div>

            <div class="upload_each_info_detail">
              <span>关&nbsp;&nbsp;键&nbsp;&nbsp;词：</span>
              <div class="key_words">
                <el-tag
                  :key="tag"
                  v-for="tag in uploadPicObj.keywords"
                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag)"
                >
                  {{tag}}
                </el-tag>
                <el-input
                  class="input-new-tag"
                  v-if="inputVisible"
                  v-model="inputValue"
                  ref="saveTagInput"
                  size="small"
                  maxlength="10"
                  :disabled='isUploadIng'
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"
                >
                </el-input>
                <el-button
                  v-else
                  class="button-new-tag"
                  size="small"
                  :disabled='isUploadIng'
                  @click="showInput"
                >+ 添加关键词</el-button>
              </div>
            </div>
            <div class="upload_each_info_detail upload_input_info_detail">
              <span>素材描述：</span>
              <el-input
                type="textarea"
                placeholder="请填写内容"
                v-model="uploadPicObj.detail"
                :disabled='isUploadIng'
                maxlength="100"
                :show-word-limit='true'
              ></el-input>
            </div>

          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import * as api from '../../../api'
import logsMixins from '../../../mixins/logs'
let OSS = require('ali-oss')
export default {
  data () {
    return {
      visible: false,
      uploadMatterData: '',
      checked: false,
      uploadMatterType: '',
      input: '',
      inputs: [],
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        multiple: true,
        emitPath: false,
        checkStrictly: true,
        expandTrigger: 'hover'
      },
      cascaderSize: 'medium',
      keywords: [],
      inputVisible: false,
      inputValue: '',
      fileAllName: '',
      uploadPicObj: {
        'repoId': '', // 必须参数： 库 ID
        'folderId': '', // 必须参数： 文件夹 ID
        'type': '', // 必须参数： 附件类型, 视频: video  音频: audio
        'vodId': '', // 必须参数： 音频或视频 ID
        'title': '', // 必须参数： 标题
        'fileName': '', // 必须参数： 文件名
        'tagIds': [], // 必须参数： 标签ID列表
        'tags': [], // 必须参数： 标签列表
        'keywords': [], // 必须参数： 关键词列表
        'detail': '',  // 必须参数： 标题
        'origin_url': '',
        'file_name': '',
        'files': ''
      },
      aliyunData: '',
      progressBar: 0,
      isUploadIng: false,
      videoAudioUploader: null,
      fileClient: null,
      currentMatterFolder: ''
    }
  },
  computed: {
    tagsTree () {
      return this.$store.state.tags.matterTagsTree
    },
    username () {
      return this.$store.state.userinfo.username
    }
  },
  mixins: [logsMixins],
  watch: {
    visible () {
      if (this.visible === false) {
        this.progressBar = 0
        var fileName = document.getElementById('fileMoreUpSend')
        fileName.value = ''
        this.fileAllName = ''
        this.isUploadIng = false
        this.aliyunData = ''
        this.inputValue = ''
        this.videoAudioUploader = null
        this.fileClient = null
        this.currentMatterFolder = ''
        this.uploadPicObj = {
          'repoId': '', // 必须参数： 库 ID
          'folderId': '', // 必须参数： 文件夹 ID
          'type': '', // 必须参数： 附件类型, 视频: video  音频: audio
          'vodId': '', // 必须参数： 音频或视频 ID
          'title': '', // 必须参数： 标题
          'fileName': '', // 必须参数： 文件名
          'tagIds': [], // 必须参数： 标签ID列表
          'tags': [], // 必须参数： 标签列表
          'keywords': [], // 必须参数： 关键词列表
          'detail': '', // 必须参数： 标题
          'origin_url': '',
          'file_name': '',
          'files': ''
        }
      }
    }
  },
  mounted () {
    this.$root.eventHub.$on('uploadMatterModel', (data, type) => {
      this.visible = true
      this.uploadMatterData = data
      this.uploadMatterType = type
      this.uploadPicObj.type = type
      this.getLastFolderChoice()
    })
    this.$root.eventHub.$on('getCurrentMatterFolder', (data) => {
      if (this.visible) {
        this.currentMatterFolder = data
        this.uploadPicObj.repoId = data.id_repo
        this.uploadPicObj.folderId = data.id
      }

    })
  },

  destroyed () {
    this.$root.eventHub.$off('uploadMatterModel')
  },
  methods: {
    choiceMatterFolder () {
      var option = {
        id_repo: this.uploadPicObj.repoId,
        id: this.uploadPicObj.folderId
      }
      this.$root.eventHub.$emit('setMatterPositionModel', option, 'matterPosition')
    },
    closeBox () {
      if (this.uploadMatterType === 'video' || this.uploadMatterType === 'audio') {
        if (this.videoAudioUploader) {
          this.videoAudioUploader.cancelFile(0)
          this.videoAudioUploader.cleanList()
          this.$notify.warning({
            title: '警告',
            message: '上传已取消'
          })
          this.getUploadVideoInfoError()
        }
      } else {
        if (this.fileClient) {
          this.fileClient.cancel()
          this.$notify.warning({
            title: '警告',
            message: '上传已取消'
          })
        }
      }
      this.videoAudioUploader = null
      this.fileClient = null
      this.visible = false
    },
    handleChange (val) {
      var node = this.$refs.cascaderref.getCheckedNodes()
      var tags = []
      for (var i = 0; i < node.length; i++) {
        for (var j = 0; j < this.uploadPicObj.tagIds.length; j++) {
          if (node[i].value === this.uploadPicObj.tagIds[j]) {
            tags.push(node[i].label)
          }
        }
      }
      this.uploadPicObj.tags = tags
    },
    handleClose (tag) {
      this.uploadPicObj.keywords.splice(this.uploadPicObj.keywords.indexOf(tag), 1)
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.uploadPicObj.keywords.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },

    onFileMoreUpSend (event) {
      var files = event.target.files || event.srcElement.files

      var fileExt = files[0].name.substr(files[0].name.lastIndexOf('.')).toLowerCase() // 获得文件后缀名
      var videoArr = ['.3gp', '.asf', '.avi', '.dat', '.dv', '.flv', '.f4v', '.gif', '.m2t', '.m4v',
        '.mj2', '.mjpeg', '.mkv', '.mov', '.mp4', '.mpe', '.mpg', '.mpeg',
        '.mts', '.ogg', '.qt', '.rm', '.rmvb', '.swf', '.ts', '.vob', '.wmv', '.webm']

      var audioArr = ['.acc', '.ac3', '.acm', '.amr', '.ape', '.caf', '.flac', '.m4a', '.mp3', '.ra', '.wav', '.wma']

      this.uploadPicObj.fileName = files[0].name
      this.uploadPicObj.file_name = files[0].name
      this.uploadPicObj.files = files[0]
      if (this.uploadMatterType === 'video') {
        var k = 0
        for (var i = 0; i < videoArr.length; i++) {
          if (videoArr[i] !== fileExt) {
            k++
          } else {
            break
          }
        }
        if (k === videoArr.length) {
          this.$notify.warning({
            title: '警告',
            message: '您上传的视频格式不对哦'
          })
        } else {
          this.fileAllName = files[0]
          var posiNum = this.fileAllName.name.lastIndexOf('.')
          if (posiNum !== -1) {
            this.uploadPicObj.title = this.fileAllName.name.substring(0, posiNum)
          } else {
            this.uploadPicObj.title = this.fileAllName.name
          }
        }
      } else if (this.uploadMatterType === 'audio') {
        var n = 0
        for (var j = 0; j < audioArr.length; j++) {
          if (audioArr[j] !== fileExt) {
            n++
          } else {
            break
          }
        }
        if (n === audioArr.length) {
          this.$notify.warning({
            title: '警告',
            message: '您上传的音频格式不对哦'
          })
        } else {
          this.fileAllName = files[0]
          var posiNumAudio = this.fileAllName.name.lastIndexOf('.')
          if (posiNumAudio !== -1) {
            this.uploadPicObj.title = this.fileAllName.name.substring(0, posiNumAudio)
          } else {
            this.uploadPicObj.title = this.fileAllName.name
          }
        }
      } else if (this.uploadMatterType === 'file') {
        this.fileAllName = files[0]
        var posiNumFile = this.fileAllName.name.lastIndexOf('.')
        if (posiNumFile !== -1) {
          this.uploadPicObj.title = this.fileAllName.name.substring(0, posiNumFile)
        } else {
          this.uploadPicObj.title = this.fileAllName.name
        }
      }
    },
    uploadMatter () {
      var fileName = document.getElementById('fileMoreUpSend')
      fileName.click()
    },
    sureUploadMatter () {
      var option = {
        ...this.$store.getters.baseOption,
        'params': this.uploadPicObj
      }
      var apiType = ''
      if (this.uploadMatterType === 'video' || this.uploadMatterType === 'audio') {
        apiType = _VIDEOAUDIOURL_
      } else if (this.uploadMatterType === 'file') {
        apiType = _IMGFILEURL_
      }
      if (this.uploadPicObj.title !== '' && this.fileAllName !== '' && this.currentMatterFolder !== '') {
        this.isUploadIng = true
        api._post(apiType + 'uploader/get_sts_info', option).then((resp) => {
          if (resp.code === 200) {
            if (this.uploadMatterType === 'video' || this.uploadMatterType === 'audio') {
              this.aliyunData = resp.data
              this.uploadPicObj.vodId = resp.data.videoId
              this.videoAudioUploader = this.createVideoAudioUploader(resp.data)
              if (this.videoAudioUploader) {
                this.selectFile(this.videoAudioUploader)
                this.videoAudioUploader.startUpload()
              }
            } else if (this.uploadMatterType === 'file') {
              this.fileClient = this.createFileClient(resp.data)
              if (this.fileClient) {
                this.uploadFile(resp.data)
              }

            }

          } else {
            this.isUploadIng = false
          }
        }).catch((error) => {
          console.log(error)
          this.isUploadIng = false
        })
      } else {
        this.$notify.warning({
          title: '警告',
          message: '请补全信息'
        })
      }
    },
    isVodMode () {
      var uploadAuth = this.aliyunData.uploadAuth
      return (uploadAuth && uploadAuth.length > 0)
    },

    isSTSMode () {
      var secretToken = this.aliyunData.securityToken
      if (!this.isVodMode()) {
        if (secretToken && secretToken.length > 0) {
          return true
        }
      }
      return false
    },
    selectFile (uploader) {
      var endpoint = ''
      var bucket = ''
      var objectPre = ''
      var userData
      if (this.isVodMode()) {
        userData = '{"Vod":{"StorageLocation":"","UserData":{"IsShowWaterMark":"false","Priority":"7"}}}'
      } else {
        userData = '{"Vod":{"StorageLocation":"","Title":"this is title.我是标题","Description":"this is desc.我是描述","CateId":"19","Tags":"tag1,tag2,标签3"}}'
      }
      if (this.isVodMode()) {
        // 点播上传。每次上传都是独立的OSS object，所以添加文件时，不需要设置OSS的属性
        uploader.addFile(this.fileAllName, null, null, null, userData)
      } else if (this.isSTSMode()) {
        // STS的上传方式，需要在userData里指定Title
        var object = objectPre
        // if(objectPre)
        // {
        //     object = objectPre +"/"+ event.target.files[i].name;
        // }
        uploader.addFile(this.fileAllName, endpoint, bucket, object, userData)
      }
    },

    createVideoAudioUploader (videoInfo) {
      var accessKeyId = videoInfo.accessKeyId
      var accessKeySecret = videoInfo.accessKeySecret
      var secretToken = videoInfo.securityToken
      var self = this
      var uploader = new AliyunUpload.Vod({
        // 文件上传失败
        'onUploadFailed': function (uploadInfo, code, message) {
          self.getUploadVideoInfoError()
        },
        // 文件上传完成
        'onUploadSucceed': function (uploadInfo) {
          self.show = false
          self.getUploadVideoInfoAfter()
        },
        // 文件上传进度
        'onUploadProgress': function (uploadInfo, totalSize, loadedPercent) {
          // log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + (loadedPercent * 100.00).toFixed(2) + "%");
          self.progressBar = Number((loadedPercent * 100.00).toFixed(2))
        },
        // STS临时账号会过期，过期时触发函数
        'onUploadTokenExpired': function (uploadInfo) {
          if (self.isVodMode()) {
            self.getUploadVideoInfoError()
            // 实现时，根据uploadInfo.videoId从新获取UploadAuth
            // 实际环境中调用点播的刷新上传凭证接口，获取凭证
            // https://help.aliyun.com/document_detail/55408.html?spm=a2c4g.11186623.6.630.BoYYcY
            // 获取上传凭证后，调用setUploadAuthAndAddress
            // uploader.resumeUploadWithAuth(uploadAuth);
          } else if (self.isSTSMode()) {
            self.getUploadVideoInfoError()
            // 实现时，从新获取STS临时账号用于恢复上传
            // uploader.resumeUploadWithSTSToken(accessKeyId, accessKeySecret, secretToken, expireTime);
          }
        },
        onUploadCanceled: function (uploadInfo) {
          console.log('onUploadCanceled:file:' + uploadInfo.file.name)
        },
        // 开始上传
        'onUploadstarted': function (uploadInfo) {
          if (self.isVodMode()) {
            if (!uploadInfo.videoId) // 这个文件没有上传异常
            {
              // mock 上传凭证，实际产品中需要通过接口获取
              var uploadAuth = videoInfo.uploadAuth
              var uploadAddress = videoInfo.uploadAddress
              var videoId = videoInfo.videoId
              // 实际环境中调用调用点播的获取上传凭证接口
              // https://help.aliyun.com/document_detail/55407.html?spm=a2c4g.11186623.6.629.CH7i3X
              // 获取上传凭证后，调用setUploadAuthAndAddress
              uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId);
            } else // 如果videoId有值，根据videoId刷新上传凭证
            {
              // mock 上传凭证 实际产品中需要通过接口获取
              var uploadAuth = videoInfo.uploadAuth;
              var uploadAddress = videoInfo.uploadAddress
              // 实际环境中调用点播的刷新上传凭证接口，获取凭证
              // https://help.aliyun.com/document_detail/55408.html?spm=a2c4g.11186623.6.630.BoYYcY
              // 获取上传凭证后，调用setUploadAuthAndAddress
              uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress)
            }
          }
          else if (self.isSTSMode()) {
            var accessKeyId = videoInfo.accessKeyId
            var accessKeySecret = videoInfo.accessKeySecret
            var secretToken = videoInfo.securityToken
            uploader.setSTSToken(uploadInfo, accessKeyId, accessKeySecret, secretToken)
          }
          console.log("onUploadStarted:" + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object)
        },
        'onUploadEnd': function (uploadInfo) {
          console.log("onUploadEnd: uploaded all the files");
        }
      })
      return uploader
    },

    getUploadVideoInfoError () {
      if (this.videoAudioUploader) {
        this.uploadPicObj.articleId = this.uploadMatterData.id
        this.uploadPicObj.success = false
        var option = {
          ...this.$store.getters.baseOption,
          'params': this.uploadPicObj
        }
        api._post(_VIDEOAUDIOURL_ + 'uploader/relationArticle', option).then((resp) => {
          if (resp.code === 200) {
            console.log('上传失败')
          }
          this.isUploadIng = false
        }).catch((error) => {
          console.log(error)
          this.isUploadIng = false
        })
      }
    },
    getUploadVideoInfoAfter () {
      if (this.videoAudioUploader) {
        this.uploadPicObj.articleId = this.uploadMatterData.id
        this.uploadPicObj.success = true
        var option = {
          ...this.$store.getters.baseOption,
          'params': this.uploadPicObj
        }
        api._post(_VIDEOAUDIOURL_ + 'uploader/relationArticle', option).then((resp) => {
          if (resp.code === 200) {
            this.$notify.success({
              title: '成功',
              message: '上传成功'
            })
            this.getRelatedMatters(this.uploadMatterData.id)
            this.$root.eventHub.$emit('setRelateMatterFlag', this.uploadMatterData.id, true)
            this.$set(this.uploadMatterData, 'flag_material', true)
            if (this.$route.path === "/editorArticle" || this.$route.path === "/atlasmanuscript") {
              try {
                window.opener.postMessage(this.uploadMatterData, '*')
              } catch (error) {
                console.log(error)
              }
            }

          }
          this.isUploadIng = false
          this.visible = false
        }).catch((error) => {
          console.log(error)
          this.isUploadIng = false
        })
      }

    },

    createFileClient (data) {
      var client = new OSS({
        region: data.region,
        accessKeyId: data.ossAuthStsInfo.accessKeyId,
        accessKeySecret: data.ossAuthStsInfo.accessKeySecret,
        stsToken: data.ossAuthStsInfo.securityToken,
        bucket: data.bucket_name
      })
      return client
    },

    uploadFile (data) {
      var posiNumFile = this.uploadPicObj.file_name.lastIndexOf('.')
      var locationName = ''
      if (posiNumFile !== -1) {
        locationName = new Date().getTime() + (Math.random() * 1000) + this.uploadPicObj.file_name.substring(posiNumFile)
      } else {
        locationName = this.uploadPicObj.file_name
      }
      this.$set(this.uploadPicObj, 'location', data.object_prefix + locationName)
      this.$set(this.uploadPicObj, 'origin_url', data.object_prefix + locationName)
      this.uploadFileToOSS(this.uploadPicObj, this.fileClient)
    },
    uploadFileToOSS (fileKeyName, client) {
      var self = this
      async function multipartUpload () {
        try {
          let result = await client.multipartUpload(fileKeyName.location, fileKeyName.files, {
            progress: function (p) {
              self.progressBar = Math.floor(p * 100)
            }
          })
          if (result.res.statusCode == 200) {
            console.log('成功')
            self.uploadSuccess()
          }
        } catch (e) {
          // 捕获超时异常
          if (e.code === 'ConnectionTimeoutError') {
            console.log("Woops,超时啦!");
            // do ConnectionTimeoutError operation
          }
          console.log(e)
        }

      }
      multipartUpload()
    },
    uploadSuccess () {
      if (this.fileClient) {
        var option = {
          ...this.$store.getters.baseOption,
          'params': {
            'repoId': this.uploadPicObj.repoId, // 必须参数： 库 ID
            'folderId': this.uploadPicObj.folderId, // 必须参数： 文件夹 ID
            'type': "file",  // 必须参数： 附件类型, 图片: picture 附件: file
            'contents': [this.uploadPicObj],
            'articleId': this.uploadMatterData.id
          }
        }
        api._post(_IMGFILEURL_ + 'uploader/relationArticle', option).then((resp) => {
          if (resp.code === 200) {
            this.$notify.success({
              title: '成功',
              message: '上传成功'
            })
            this.getRelatedMatters(this.uploadMatterData.id)
            this.$root.eventHub.$emit('setRelateMatterFlag', this.uploadMatterData.id, true)

            this.$set(this.uploadMatterData, 'flag_material', true)
            if (this.$route.path === "/editorArticle" || this.$route.path === "/atlasmanuscript") {
              try {
                window.opener.postMessage(this.uploadMatterData, '*')
              } catch (error) {
                console.log(error)
              }
            }

            this.visible = false
          }
          this.isUploadIng = false
        }).catch((error) => {
          console.log(error)
          this.isUploadIng = false
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.detail_box
  .detail
    position relative
    width 560px
    height 650px
    border-radius 6px
    background #FFFFFF
    box-shadow 0px 1px 4px 0px rgba(0, 0, 0, 0.35)

    .titles
      clear both
      box-sizing border-box
      padding 0 14px 0 14px
      height 48px
      background #fff
      box-shadow 0px 0px 4px 0px rgba(0, 0, 0, 0.2)

      .title_name
        float left
        color #303133
        font-size 16px
        line-height 48px

      .iconfont
        float right
        color #606266
        font-size 22px
        line-height 48px
        cursor pointer

    .detail_el_scroll
      position relative
      box-sizing border-box
      height calc(100% - 48px)

      .bottom_button
        position absolute
        bottom 0
        left 0
        box-sizing border-box
        padding-right 20px
        padding-left 20px
        width 100%
        height 60px

        .bottom_content
          display flex
          justify-content center
          align-items center
          width 100%
          height 60px

          button
            height 38px
            line-height 0

      .upload_matter_info
        overflow auto
        height calc(100% - 60px)

        .upload_matter_button
          display flex
          padding 14px 0 20px 76px

          button
            margin-right 10px
            padding 0
            width 110px
            height 38px

          span
            display inline-block
            overflow hidden
            width 300px
            color #606266
            text-overflow ellipsis
            white-space nowrap
            font-size 14px
            line-height 38px

        .upload_progress
          margin-bottom 20px
          padding-left 77px
          width 400px
          height 24px

        .upload_each_info_detail
          display flex
          box-sizing border-box
          margin-bottom 20px
          padding-left 77px

          span
            color #606266
            font-size 14px

          .need_textdot
            display inline-block
            overflow hidden
            width 76%
            text-overflow ellipsis
            white-space nowrap

          .key_words
            box-sizing border-box
            padding 10px 10px 10px 10px
            min-height 80px
            width 330px
            border 1px solid #DBE0EC
            border-radius 4px
            background #F7F8FA

        .upload_input_info_detail, .upload_input_tags_detail
          span
            line-height 36px

          .star
            margin-right 4px
            color #F56969
</style>
